import {
  Alert,
  Box,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import { login, verify_otp } from "../../services/auth.service";
import "../../assets/styles/login.css";
import { VisibilityOutlined, VisibilityOffOutlined } from "@mui/icons-material";
import { save_role } from "../../controllers/helps.controller";
import Localization from "../../contexts/Localization";
import { FormattedMessage, useIntl } from "react-intl";

const Login = () => {
  const intl = useIntl();
  const loginButtonRef = useRef(null);
  const [stateLogin, setStateLogin] = useState("login");
  const [htmlImg, setHtmlImg] = useState("");
  const [preName, setPreName] = useState("");
  const [typePass, setTypePass] = useState(true);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");


  console.log("intlintlintl", intl);
  const submitLogin = async () => {
    let parentElement = document.getElementById("error-text");
    let childElement = parentElement.querySelector(".MuiAlert-message");

    if (!username || !password) {
      parentElement.classList.remove("none-display");
      childElement.innerHTML = "Vui lòng nhập đầy đủ thông tin.";

      childElement.innerHTML = intl.formatMessage({ id: "please_provide_full_information" });
    } else {
      setPreName(username);
      let handleLogin = await login(username, password);
      
      if (handleLogin.status_code === 403) {
        return Swal.fire({
          icon: "error",
          title: intl.formatMessage({ id: "login_failed" }),
          text: intl.formatMessage({ id: "access_denied_message" }) + intl.formatMessage({ id: "your_ip" }) + handleLogin.your_ip,
        });
      }
      if (handleLogin.valid === false) {
        return Swal.fire({
          icon: "error",
          title: intl.formatMessage({ id: "login_failed" }),
          text: handleLogin.mess[intl.locale],
        });
      }
      if (handleLogin.isFirstTimeVerify) {
        setStateLogin("qrcode");
        setHtmlImg(handleLogin.html);
      } else if (!handleLogin.isFirstTimeVerify) {
        setStateLogin("verifyOTP");
      }
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        loginButtonRef.current.click();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      // Hủy bỏ bộ lắng nghe khi thành phần bị hủy
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handlePostOTP = async () => {
    let otp = document.getElementById("otp").value;
    if (!otp) {
      return Swal.fire({ icon: "error", text: intl.formatMessage({ id: "please_enter_verification_code" })});

    }
    let post = await verify_otp(otp, preName);
    if (post.valid === false) {
      return Swal.fire({ icon: "error", text: post.mess[intl.locale], });
    }
    if (post.valid === true) {
      save_role(post.role);
      localStorage.setItem("username-redeem", post.username);
      localStorage.setItem("token-redeem", post.token);
      window.location.replace("/");
    }
  };
  return (
    <Box className="login-page">
      <Box className="login-bg-banner">
        <Box
          className="login-banner"
          sx={{
            borderRadius: "18px",
            backgroundColor: "white",
            width: 520,
            p: 8,
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px;",
            position: "relative",
          }}
        >
          <Box sx={{ mb: 2 }} top={30} position={"absolute"} right={10}>
            <Localization />
          </Box>

          {stateLogin === "login" && (
            <>
              <Typography
                fontWeight={800}
                variant="h5"
                sx={{ mb: 4, textAlign: "center" }}
              >
                {<FormattedMessage id="Management Page CODE" />}
              </Typography>
              <Alert
                id="error-text"
                className="none-display"
                sx={{ fontSize: "1em", fontWeight: 700, mb: 2, mt: 2 }}
                severity="error"
              ></Alert>
              <Box sx={{ mb: 2 }}>
                <Typography fontWeight={"bold"} sx={{ mb: 1 }}>
                  <FormattedMessage id="username login" />
                </Typography>
                <TextField
                  size="small"
                  sx={{ width: "100%" }}
                  value={username}
                  onChange={(ele) => setUsername(ele.target.value)}
                  placeholder={intl.formatMessage({ id: "enter username" })}

                  type="text"
                  autoFocus=""
                  autoComplete="off"
                />
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography fontWeight={"bold"} sx={{ mb: 1 }}>
                  {<FormattedMessage id="password" />}
                  {/* {intl.formatMessage({ id: 'password' })} */}
                </Typography>
                <Box sx={{ position: "relative" }}>
                  <TextField
                    size="small"
                    sx={{ width: "100%" }}
                    value={password}
                    onChange={(ele) => setPassword(ele.target.value)}
                    placeholder={intl.formatMessage({ id: "enter password"})}
                    type={typePass ? "password" : "text"}
                    autoComplete="off"
                  />
                  <Box
                    sx={{ position: "absolute", top: 0, right: 0, m: 1 }}
                    onClick={() => setTypePass(!typePass)}
                  >
                    {typePass && <VisibilityOffOutlined />}
                    {!typePass && <VisibilityOutlined />}
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  cursor: "pointer",
                  backgroundColor: "black",
                  color: "white",
                  textAlign: "center",
                  p: 1.3,
                  mt: 5,
                  borderRadius: 30,
                  transition: "background-color 0.3s, color 0.3s",
                  "&:hover": {
                    backgroundColor: "#1c1c1c",
                  },
                  "&:active": {
                    backgroundColor: "grey",
                  },
                }}
                ref={loginButtonRef}
                onClick={submitLogin}
              >
                {<FormattedMessage id="login" />}
              </Box>
            </>
          )}
          {stateLogin === "verifyOTP" && (
            <>
              <Typography fontWeight={800} variant="h5" sx={{ mb: 4 }}>
                {<FormattedMessage id="Management Page CODE" />}
              </Typography>
              <Alert
                id="error-text"
                className="none-display"
                sx={{ fontSize: "1em", fontWeight: 700, mb: 2, mt: 2 }}
                severity="error"
              ></Alert>
              <Box sx={{ mb: 2 }}>
                <Typography fontWeight={"bold"} sx={{ mb: 1 }}>
                  <FormattedMessage id="username login" />
                </Typography>
                <TextField
                  size="small"
                  sx={{ width: "100%" }}
                  type="text"
                  autoFocus=""
                  autoComplete="off"
                  value={preName}
                  disabled
                />
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography fontWeight={"bold"} sx={{ mb: 1 }}>
                  <FormattedMessage id="verification code" />
                </Typography>
                <Box sx={{ position: "relative" }}>
                  <TextField
                    id="otp"
                    size="small"
                    sx={{ width: "100%" }}
                    placeholder={intl.formatMessage({ id: "enter verification code"})}
                    type="text"
                    autoComplete="off"
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  cursor: "pointer",
                  backgroundColor: "black",
                  color: "white",
                  textAlign: "center",
                  p: 1.3,
                  mt: 5,
                  borderRadius: 30,
                  transition: "background-color 0.3s, color 0.3s",
                  "&:hover": {
                    backgroundColor: "#1c1c1c",
                  },
                  "&:active": {
                    backgroundColor: "grey",
                  },
                }}
                ref={loginButtonRef}
                onClick={handlePostOTP}
              >
                
                <FormattedMessage id="confirm" />
              </Box>
            </>
          )}
          {stateLogin === "qrcode" && (
            <Box>
              <Typography
                fontWeight={800}
                variant="h5"
                sx={{ mb: 4 }}
                textAlign={"center"}
              >
                <FormattedMessage id="scan the verification code" />
                
              </Typography>
              <Stack justifyContent={"center"} alignItems={"center"}>
                <img
                  src={htmlImg}
                  alt="qrcode-admin-code"
                  border={1}
                  width={300}
                  height={300}
                />
              </Stack>
              <Box
                sx={{
                  cursor: "pointer",
                  backgroundColor: "black",
                  color: "white",
                  textAlign: "center",
                  p: 1.3,
                  mt: 5,
                  borderRadius: 30,
                  transition: "background-color 0.3s, color 0.3s",
                  "&:hover": {
                    backgroundColor: "#1c1c1c",
                  },
                  "&:active": {
                    backgroundColor: "grey",
                  },
                }}
                ref={loginButtonRef}
                onClick={() => setStateLogin("verifyOTP")}
              >
                
                <FormattedMessage id="enter verification code" />
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
